import { render, staticRenderFns } from "./LoaderVideoBrandme.vue?vue&type=template&id=5a6d8804&scoped=true&"
import script from "./LoaderVideoBrandme.vue?vue&type=script&lang=js&"
export * from "./LoaderVideoBrandme.vue?vue&type=script&lang=js&"
import style0 from "./LoaderVideoBrandme.vue?vue&type=style&index=0&id=5a6d8804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d8804",
  null
  
)

export default component.exports